var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"finance-history"},[_c('FinanceTable',{attrs:{"loading":_vm.loading,"value":_vm.data,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }